import {Injectable} from "@angular/core";
import {AbstractBaseComponent} from "../app.baseComponent";
import {CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import {map} from "rxjs/operators";
import {AuthenticationHelper} from "../helpers/authenticationHelper";
import {UtilityHelper} from "../helpers/utilityHelper";
import {ChannelAccessService} from "../appServices/channel-access.service";
import {ActivatedRouteSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import { shouldRedirectToWaitingListFromStorage } from "../helpers/openAccessWaitingList.helper";

@Injectable()
export class ChannelAccessGuard extends AbstractBaseComponent implements CanActivate {
    isArchive: string = '';

    constructor(private authService: AuthenticationHelper, private utility: UtilityHelper,
                private route: Router, private channelAccess: ChannelAccessService) {
        super();
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        if (this.authService.isLoggedIn()) {
            if (shouldRedirectToWaitingListFromStorage(this.utility)) {
                this.route.navigate(['/waiting-list']);
                return false;
            }
            let hasAccess = this.utility.getItem('isChannelAccess');
            let isTourPending = this.utility.getItem('isTourPending');
            this.isArchive = this.utility.getItem('isProjectUserArchived');
            if(state.url.includes("message_id")) {
                let channelId = state.url.match(/message_id=([^&#]+)/);
                if(channelId){
                    this.utility.setItem("messageId",channelId[1])
                }
            }
            if (isTourPending == 'true' || this.isArchive === 'true') {
                return true;
            }
            // Mentors are never blocked by the compulsory entry-survey gate
            // (ChannelAccessService.decide). A stale `isChannelAccess=False`
            // from another project must not bounce them — especially hub mentors,
            // where navigate(['']) hits PreLogin → Mentor Hub.
            if (this.utility.getItem('role') === 'mentor') {
                this.channelAccess.grantAccess();
                return true;
            }
            if ([this.ADMIN_DOMAIN, this.BRILLIANTCLUB_DOMAIN].includes(this.utility.myDomain)) {
                return true;
            }
            if ([this.LOCAL_DOMAIN, this.MENTORING_DOMAIN].includes(this.utility.myDomain)) {
                // The flag is normally written by FeedsComponent / LeftSideMenu. When
                // the user came in through a shell that renders neither — or simply
                // navigated before those finished — ask for it rather than reading an
                // unset value as a denial.
                if (this.channelAccess.isResolved()) {
                    return this.grantOrRedirect(this.channelAccess.hasAccess());
                }
                return this.channelAccess.resolve().pipe(
                    map(granted => this.grantOrRedirect(granted)),
                );
            }
            return this.grantOrRedirect(false);
        } else {
            if (state.url) {
                let channelId = state.url.match(/channels\/(.+)/);
                if (channelId && channelId.length >= 2) {
                    this.route.navigate(['sign-in'], { queryParams: { 'channel_id': channelId[1] } });
                } else {
                    this.route.navigate(['']);
                }
            } else {
                this.route.navigate(['']);
            }
            return false;
        }
    }

    private grantOrRedirect(granted: boolean): boolean {
        if (!granted) {
            // Stay inside the active experience. `/` sends hub mentors to Mentor Hub
            // via PreLoginGuard and feels like Conversations "keeps redirecting".
            if (this.utility.getItem('automation_enabled') === 'true') {
                const role = this.utility.getItem('role');
                this.route.navigate(role === 'mentor' ? ['/gamification/mentor'] : ['/gamification']);
            } else {
                this.route.navigate(['/feeds']);
            }
        }
        return granted;
    }
}
